import { Link } from "react-router-dom";
import { categoryMeta } from "@/lib/content";
import type { CategoryType } from "@/types/content";

const order: CategoryType[] = ["news", "recommend", "character"];

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
      {order.map((type, index) => {
        const meta = categoryMeta[type];
        const isAccent = index === 1;
        return (
          <Link
            key={type}
            to={meta.route}
            className={`group flex items-center gap-4 rounded-lg border p-4 md:p-5 transition-all cursor-pointer ${
              isAccent
                ? "border-primary-200 bg-primary-50 hover:border-primary-300"
                : "border-background-200 bg-background-50 hover:border-secondary-300"
            }`}
          >
            <span
              className={`shrink-0 w-14 h-14 md:w-16 md:h-16 rounded-lg flex items-center justify-center text-2xl md:text-3xl ${
                isAccent ? "bg-primary-500 text-foreground-950" : "bg-secondary-100 text-accent-700"
              }`}
            >
              <i className={meta.icon}></i>
            </span>
            <div className="min-w-0">
              <h3 className="font-display font-bold text-base md:text-lg text-foreground-950">
                {meta.title}
              </h3>
              <p className="mt-1 text-xs md:text-sm text-foreground-500 line-clamp-2">
                {meta.desc}
              </p>
            </div>
            <i className="ri-arrow-right-line ml-auto shrink-0 text-foreground-400 group-hover:text-accent-600 group-hover:translate-x-0.5 transition-all text-xl w-6 h-6 flex items-center justify-center"></i>
          </Link>
        );
      })}
    </div>
  );
}